/**
 * AI Fire API
 * API to access AI Fire sensor data
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import Address from './Address';
import UserBase from './UserBase';

/**
 * The UserCreate model module.
 * @module model/UserCreate
 * @version 1.1.0
 */
class UserCreate {
    /**
     * Constructs a new <code>UserCreate</code>.
     * Used when creating a new user. Server sets ID and timestamps. isAdmin defaults to false if not provided.
     * @alias module:model/UserCreate
     * @implements module:model/UserBase
     */
    constructor() { 
        UserBase.initialize(this);
        UserCreate.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
        obj['userId'] = userId;
    }

    /**
     * Constructs a <code>UserCreate</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/UserCreate} obj Optional instance to populate.
     * @return {module:model/UserCreate} The populated <code>UserCreate</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new UserCreate();
            UserBase.constructFromObject(data, obj);

            if (data.hasOwnProperty('userId')) {
                obj['userId'] = ApiClient.convertToType(data['userId'], 'String');
            }
            if (data.hasOwnProperty('tempPassword')) {
                obj['tempPassword'] = ApiClient.convertToType(data['tempPassword'], 'String');
            }
            if (data.hasOwnProperty('firstName')) {
                obj['firstName'] = ApiClient.convertToType(data['firstName'], 'String');
            }
            if (data.hasOwnProperty('lastName')) {
                obj['lastName'] = ApiClient.convertToType(data['lastName'], 'String');
            }
            if (data.hasOwnProperty('email')) {
                obj['email'] = ApiClient.convertToType(data['email'], 'String');
            }
            if (data.hasOwnProperty('phoneNumber')) {
                obj['phoneNumber'] = ApiClient.convertToType(data['phoneNumber'], 'String');
            }
            if (data.hasOwnProperty('fireDeptId')) {
                obj['fireDeptId'] = ApiClient.convertToType(data['fireDeptId'], 'String');
            }
            if (data.hasOwnProperty('address')) {
                obj['address'] = ApiClient.convertToType(data['address'], Address);
            }
            if (data.hasOwnProperty('isAdmin')) {
                obj['isAdmin'] = ApiClient.convertToType(data['isAdmin'], 'Boolean');
            }
            if (data.hasOwnProperty('enabled')) {
                obj['enabled'] = ApiClient.convertToType(data['enabled'], 'Boolean');
            }
            if (data.hasOwnProperty('notes')) {
                obj['notes'] = ApiClient.convertToType(data['notes'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>UserCreate</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>UserCreate</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of UserCreate.RequiredProperties) {
            if (!data.hasOwnProperty(property)) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }
        // ensure the json data is a string
        if (data['userId'] && !(typeof data['userId'] === 'string' || data['userId'] instanceof String)) {
            throw new Error("Expected the field `userId` to be a primitive type in the JSON string but got " + data['userId']);
        }
        // ensure the json data is a string
        if (data['tempPassword'] && !(typeof data['tempPassword'] === 'string' || data['tempPassword'] instanceof String)) {
            throw new Error("Expected the field `tempPassword` to be a primitive type in the JSON string but got " + data['tempPassword']);
        }
        // ensure the json data is a string
        if (data['firstName'] && !(typeof data['firstName'] === 'string' || data['firstName'] instanceof String)) {
            throw new Error("Expected the field `firstName` to be a primitive type in the JSON string but got " + data['firstName']);
        }
        // ensure the json data is a string
        if (data['lastName'] && !(typeof data['lastName'] === 'string' || data['lastName'] instanceof String)) {
            throw new Error("Expected the field `lastName` to be a primitive type in the JSON string but got " + data['lastName']);
        }
        // ensure the json data is a string
        if (data['email'] && !(typeof data['email'] === 'string' || data['email'] instanceof String)) {
            throw new Error("Expected the field `email` to be a primitive type in the JSON string but got " + data['email']);
        }
        // ensure the json data is a string
        if (data['phoneNumber'] && !(typeof data['phoneNumber'] === 'string' || data['phoneNumber'] instanceof String)) {
            throw new Error("Expected the field `phoneNumber` to be a primitive type in the JSON string but got " + data['phoneNumber']);
        }
        // ensure the json data is a string
        if (data['fireDeptId'] && !(typeof data['fireDeptId'] === 'string' || data['fireDeptId'] instanceof String)) {
            throw new Error("Expected the field `fireDeptId` to be a primitive type in the JSON string but got " + data['fireDeptId']);
        }
        // validate the optional field `address`
        if (data['address']) { // data not null
          Address.validateJSON(data['address']);
        }
        // ensure the json data is a string
        if (data['notes'] && !(typeof data['notes'] === 'string' || data['notes'] instanceof String)) {
            throw new Error("Expected the field `notes` to be a primitive type in the JSON string but got " + data['notes']);
        }

        return true;
    }


}

UserCreate.RequiredProperties = ["userId"];

/**
 * @member {String} userId
 */
UserCreate.prototype['userId'] = undefined;

/**
 * Temporary password for the new user. If provided, sent to the user via email.
 * @member {String} tempPassword
 */
UserCreate.prototype['tempPassword'] = undefined;

/**
 * @member {String} firstName
 */
UserCreate.prototype['firstName'] = undefined;

/**
 * @member {String} lastName
 */
UserCreate.prototype['lastName'] = undefined;

/**
 * @member {String} email
 */
UserCreate.prototype['email'] = undefined;

/**
 * @member {String} phoneNumber
 */
UserCreate.prototype['phoneNumber'] = undefined;

/**
 * @member {String} fireDeptId
 */
UserCreate.prototype['fireDeptId'] = undefined;

/**
 * @member {module:model/Address} address
 */
UserCreate.prototype['address'] = undefined;

/**
 * @member {Boolean} isAdmin
 */
UserCreate.prototype['isAdmin'] = undefined;

/**
 * @member {Boolean} enabled
 */
UserCreate.prototype['enabled'] = undefined;

/**
 * @member {String} notes
 */
UserCreate.prototype['notes'] = undefined;


// Implement UserBase interface:
/**
 * @member {String} firstName
 */
UserBase.prototype['firstName'] = undefined;
/**
 * @member {String} lastName
 */
UserBase.prototype['lastName'] = undefined;
/**
 * @member {String} email
 */
UserBase.prototype['email'] = undefined;
/**
 * @member {String} phoneNumber
 */
UserBase.prototype['phoneNumber'] = undefined;
/**
 * @member {String} fireDeptId
 */
UserBase.prototype['fireDeptId'] = undefined;
/**
 * @member {module:model/Address} address
 */
UserBase.prototype['address'] = undefined;
/**
 * @member {Boolean} isAdmin
 */
UserBase.prototype['isAdmin'] = undefined;
/**
 * @member {Boolean} enabled
 */
UserBase.prototype['enabled'] = undefined;
/**
 * @member {String} notes
 */
UserBase.prototype['notes'] = undefined;




export default UserCreate;

